import { Controller } from "@hotwired/stimulus"
import { toggle } from "el-transition"

// Civic Warmth replacement for Bootstrap's collapse (data-bs-toggle="collapse").
// Used for mobile nav and disclosure sections in converted views.
//
//   <div data-controller="collapse">
//     <button data-action="collapse#toggle" aria-expanded="false">Menu</button>
//     <div data-collapse-target="panel" class="hidden" data-transition-enter="..." ...>
//       ...
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["panel", "button"]

  toggle() {
    toggle(this.panelTarget)
    if (this.hasButtonTarget) {
      const expanded = this.buttonTarget.getAttribute("aria-expanded") === "true"
      this.buttonTarget.setAttribute("aria-expanded", (!expanded).toString())
    }
  }
}
